import { AnyAction } from 'redux';

import { PlaybackState } from '../videoplayerui/infobanner/PlaybackTypes';
import {
    HIDE_STILL_THERE_OSD,
    IS_STILL_THERE,
    SET_EXIT_PLAYER_TIMER,
    SHOW_STILL_THERE_OSD,
    UPDATE_STILL_THERE_TIMER,
    VIDEO_PLAYER_IS_PAUSE_BUTTON_PRESSED,
    VIDEO_PLAYER_RESET_RETRY,
    VIDEO_PLAYER_SET_PLAYBACK_STATE,
    VIDEO_PLAYER_TOGGLE_IS_PLAYING,
} from './videoplayer.types';

export const videoPlayerResetRetryAction = (): AnyAction => ({
    type: VIDEO_PLAYER_RESET_RETRY,
});

export const videoPlayerToggleIsPlayingAction = (isPlaying: boolean): AnyAction => ({
    type: VIDEO_PLAYER_TOGGLE_IS_PLAYING,
    payload: {
        isPlaying,
    },
});

export const videoPlayerSetPlaybackStateAction = (playbackState: PlaybackState): AnyAction => ({
    type: VIDEO_PLAYER_SET_PLAYBACK_STATE,
    payload: {
        playbackState,
    },
});

export const videoPlayerIsMediaButtonPressedAction = ({
    type,
    isMediaButtonPressed,
}): AnyAction => ({
    type: VIDEO_PLAYER_IS_PAUSE_BUTTON_PRESSED,
    payload: {
        mediaButtonPressed: {
            type,
            isMediaButtonPressed,
        },
    },
});

export const showStillThereOsdAction = (): AnyAction => ({
    type: SHOW_STILL_THERE_OSD,
    payload: { isStillThereOsdActive: true },
});

export const hideStillThereOsdAction = (): AnyAction => ({
    type: HIDE_STILL_THERE_OSD,
    payload: { isStillThereOsdActive: false },
});

export const resetStillThereTimeoutAction = (stillThereTimer: any): AnyAction => ({
    type: UPDATE_STILL_THERE_TIMER,
    payload: {
        stillThereTimer,
    },
});

export const isStillThereAction = (isStillThere: boolean): AnyAction => ({
    type: IS_STILL_THERE,
    payload: {
        isStillThere,
    },
});

export const setExitPlayerTimeoutAction = (exitPlayerTimer: any): AnyAction => ({
    type: SET_EXIT_PLAYER_TIMER,
    payload: {
        exitPlayerTimer,
    },
});
